<template>
  <v-card outlined class="d-flex ma-4">
    <EventListItem
      :item="item"
      v-for="item of list"
      :key="item.id"
    ></EventListItem>
  </v-card>
</template>

<script>
import EventListItem from "../Event/EventListItem";
export default {
  components: { EventListItem },
  data: () => ({
    list: []
  }),
  async mounted() {
    try {
      let { data: list } = await this.$http.get("event", {
        params: {
          sort: "occurrenceQuantity DESC",
          limit: 3
        }
      });
      this.list = list;
    } catch (err) {}
  }
};
</script>

<style></style>
